import {
  faBolt,
  faUserCircle,
  faExclamationTriangle,
  faComments,
} from '@fortawesome/free-solid-svg-icons';
import { getAssigneeName } from './WorkflowConditionEnum';

export const WorkflowActionEnum = {
  ASSIGN_DOCUMENT: {
    value: 'ASSIGN_DOCUMENT',
    label: 'Assign document to',
    title: 'Assign Document',
    paramKey: 'assigneeId',
  },
  UPDATE_RISK_CATEGORY: {
    value: 'UPDATE_RISK_CATEGORY',
    label: 'Update urgency to',
    title: 'Update Urgency',
    paramKey: 'riskCategory',
  },
  ADD_COMMENT: {
    value: 'ADD_COMMENT',
    label: 'Add comment',
    title: 'Add Comment',
    paramKey: 'comment',
  },
};

export const WORKFLOW_ACTION_TYPE_OPTIONS = Object.values(WorkflowActionEnum).map(
  ({ value, label }) => ({ value, name: label })
);

// Shared dropdown option lists
export const RISK_CATEGORY_OPTIONS = [
  { value: 'HIGH', name: 'High' },
  { value: 'MEDIUM', name: 'Medium' },
  { value: 'LOW', name: 'Low' },
];

export const DEFAULT_NEW_ACTION = {
  type: WorkflowActionEnum.ASSIGN_DOCUMENT.value,
  assigneeId: null,
};

export function createDefaultAction(type) {
  switch (type) {
    case WorkflowActionEnum.ASSIGN_DOCUMENT.value:
      return { type, assigneeId: null };
    case WorkflowActionEnum.UPDATE_RISK_CATEGORY.value:
      return { type, riskCategory: 'HIGH' };
    case WorkflowActionEnum.ADD_COMMENT.value:
      return { type, comment: '' };
    default:
      return { type };
  }
}

export function getWorkflowActionParamKey(type) {
  return WorkflowActionEnum[type]?.paramKey ?? null;
}

export function getWorkflowActionTitle(action) {
  return WorkflowActionEnum[action.type]?.title ?? 'Action';
}

export function formatWorkflowActionText(action, activeUsers, teams) {
  switch (action.type) {
    case WorkflowActionEnum.ASSIGN_DOCUMENT.value:
      return `Assign document to ${getAssigneeName(action.assigneeId, activeUsers, teams)}`;
    case WorkflowActionEnum.UPDATE_RISK_CATEGORY.value:
      return `Update urgency to ${action.riskCategory}`;
    case WorkflowActionEnum.ADD_COMMENT.value: {
      const comment = action.comment || '';
      return comment.length > 60 ? comment.substring(0, 60) + '...' : comment;
    }
    default:
      return action.type;
  }
}

export function getWorkflowActionIcon(action) {
  switch (action.type) {
    case WorkflowActionEnum.ASSIGN_DOCUMENT.value:
      return faUserCircle;
    case WorkflowActionEnum.UPDATE_RISK_CATEGORY.value:
      return faExclamationTriangle;
    case WorkflowActionEnum.ADD_COMMENT.value:
      return faComments;
    default:
      return faBolt;
  }
}
